export const TIME_MENU_CLASS = "max-h-72 overflow-y-auto overscroll-contain";

export function scrollSelectedTime(open: boolean) {
  if (!open) return;
  window.requestAnimationFrame(() => {
    const selected = document.querySelector<HTMLElement>(
      '[role="menuitemradio"][aria-checked="true"]',
    );
    const menu = selected?.parentElement;
    if (!selected || !menu) return;
    menu.scrollTop = selected.offsetTop - menu.clientHeight / 2;
  });
}
